
import Vue, { PropType } from "vue";

export default Vue.extend({
  props: {
    acceptedType: {
      type: String,
      required: false,
      default: undefined,
    },
    multiple: Boolean,
    value: [File, Array, Object] as PropType<File | File[] | FileList>,
  },
  data() {
    return {
      files: [] as File[],
      dragover: false,
      empty: true,
    };
  },
  methods: {
    addFiles(newFiles: File | File[] | FileList) {
      newFiles = newFiles instanceof File ? [newFiles] : newFiles;

      if (this.multiple === true) {
        newFiles = [...newFiles, ...this.files];
      } else {
        newFiles = [newFiles[0]];
      }
      this.files = newFiles;

      this.refresh();
      this.dragover = false;
    },
    disableDragover() {
      this.dragover = false;
    },
    enableDragover() {
      this.dragover = true;
    },
    getFilledZoneHeight() {
      return getComputedStyle(this.$refs.filledZone as Element).height;
    },
    launchClick() {
      (this.$refs.fileUpload as HTMLElement).click();
    },
    onDrop(event: any) {
      event.preventDefault();
      this.addFiles(event.dataTransfer.files);
    },
    onFileChange(e: any) {
      if (e.target.value) {
        // fix behaviour on Chrome (not on Firefox) with !multiple (single select only)
        // when a file is already selected:
        //  - if user reopens file selection box
        //  => a 'change' event is launched when user clicks on "cancel" (!?)
        this.addFiles(e.target.files || e.dataTransfer.files);
      }
    },
    removeFiles(index: number) {
      this.files.splice(index, 1);
      if (!this.files.length) {
        (this.$refs.fileUpload as HTMLInputElement).value = "";
      }
      this.refresh();
    },
    refresh() {
      this.empty = this.files.length == 0;
      this.$emit("input", this.multiple ? this.files : this.files[0]);
    },
  },
});
